import { Sorting } from '../../../../components/Lists/Sorting';
import './AwbDetail.scss';

const properties = ["orderNumber", "orderType", "partNumber", "partName", "quantity"];

export const AwbDetail = ({ awb, orders, hideTitle }) => {
    return (
        <div className="awb-detail-component">
            {!hideTitle && <b>Detail AWB No {Boolean(awb) ? `- ${awb}` : "--"}</b>}
            <div className='sorting-mobile'>
                <Sorting initialSort={"orderNumber"} hideArrows displayButton={false} onOrderChange={() => { }} properties={{ orderNumber: "Order", orderType: "Type", partNumber: "PN", partName: "Description", quantity: "QTY" }} />
            </div>
            <div className='sorting-general'>
                <Sorting initialSort={"orderNumber"} displayButton={false} onOrderChange={() => { }} properties={{ orderNumber: "Order", orderType: "Type", partNumber: "PN", partName: "Description", quantity: "QTY" }} />
            </div>
            {

                Boolean(awb) ? (
                    orders.length > 0 ? orders.map(order => <div className="order">
                        {properties.map(key =>
                            <span key={key}>
                                {order[key]}
                            </span>)}
                    </div>) :
                        <div className='placeholder-component'>
                            <i>No orders found on the selected AWB number</i>
                        </div>
                ) :
                    <div className='placeholder-component'>
                        <i>Select an AWB to display orders</i>
                    </div>
            }
            {
            }
        </div>
    )

}